import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyForm } from 'src/app/classes/form-groups/company-form';
import { Company } from 'src/app/classes/models';

@Component({
  selector: 'app-edit-fee-vouchers-modal',
  templateUrl: './edit-fee-vouchers-modal.component.html',
  styleUrl: './edit-fee-vouchers-modal.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EditFeeVouchersModalComponent {
  constructor(private activeModal: NgbActiveModal) {}

  @Input() CompanyForm?: CompanyForm;
  @Input() Company?: Company;

  close() {
    this.activeModal.dismiss('Cross Click');
  }

  save() {
    Object.assign(this.Company!, this.CompanyForm?.getRawValue());
    this.activeModal.close();
  }
}
